import type { RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/checkIn',
    name: 'checkIn',
    meta: {
      title: '签到详情',
      isApp: true,
      auth: false,
    },
    component: () => import('@/views/checkIn/index.vue'),
  },
  {
    path: '/checkIn/reward',
    name: 'checkInReward',
    meta: {
      title: '签到奖励',
      isApp: true,
      auth: false,
    },
    component: () => import('@/views/checkIn/reward.vue'),
  },
  {
    path: '/checkIn/rules',
    name: 'checkInRules',
    meta: {
      title: '签到规则',
      isApp: true,
      auth: false,
    },
    component: () => import('@/views/checkIn/rules.vue'),
  },
]

export default routes
